import { Component, type ReactNode } from 'react'
import { Button } from '@brent/core-ui/ui'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }

      return (
        <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-6">
          <h2 className="font-semibold text-destructive">Something went wrong</h2>
          <p className="mt-1 text-sm text-muted-foreground">
            {this.state.error?.message || 'An unexpected error occurred.'}
          </p>
          <Button variant="outline" size="sm" onClick={this.handleReset} className="mt-4">
            Try again
          </Button>
        </div>
      )
    }

    return this.props.children
  }
}
